import PropTypes from 'prop-types'
import css from '../info-fields.css'

const Username = ({ value, onChange }) => (
    <div className={css.field}>
        <label className={css.label}>Username</label>
        <input
            className={css.input}
            type="url"
            value={value}
            placeholder="Enter a user"
            onChange={(e) => onChange({ username: e.target.value })}
        />
    </div>
)

Username.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

export default Username
